export default __webpack_public_path__ + "static/media/element-logo.9a5a405c.svg";